import { Link } from "react-router-dom";
import { allTopics, getCategoryById } from "@/lib/articles";
import { formatShortDate } from "@/lib/articles";

export default function FeaturedTopics() {
  const [featured, ...rest] = allTopics;
  const featuredCategory = getCategoryById(featured?.categoryId);

  return (
    <section className="w-full rounded-lg bg-background-100 p-4 md:p-6">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            精选专题推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-600">围绕热点话题，深读一组好内容</p>
        </div>
        <Link
          to="/search?q=专题"
          className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          全部专题
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {featured && (
          <Link
            to={`/search?q=${encodeURIComponent(featured.title)}`}
            className="group relative block overflow-hidden rounded-lg bg-secondary-900 cursor-pointer"
          >
            <div className="h-64 w-full lg:h-full lg:min-h-[320px] overflow-hidden">
              <img
                src={featured.cover}
                alt={featured.title}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                <i className="ri-compass-3-line w-4 h-4 flex items-center justify-center"></i>
                本期主推 · {featuredCategory?.name}
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-white md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm text-white/80">{featured.summary}</p>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
          {rest.map((topic) => {
            const category = getCategoryById(topic.categoryId);
            return (
              <Link
                key={topic.id}
                to={`/search?q=${encodeURIComponent(topic.title)}`}
                className="group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={topic.cover}
                    alt={topic.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-col justify-center">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
                      {category?.name}
                    </span>
                    <span>{formatShortDate(topic.date)}</span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-2 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {topic.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-xs text-foreground-600">{topic.summary}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}